import Swiper from 'swiper'
export default function index(gsap, ScrollTrigger){

  if(document.querySelectorAll('.site-index').length > 0){
    ScrollTrigger.create({
      trigger: ".site-index .concept__pics__abs",
      start: "top top",
      end: "+=75%",
      pin: true,
      //markers: true
    })
  
    gsap.utils.toArray('.site-index .concept__pics__item').forEach((el, index) => {
      const m = index == 0 ? -1 : 1
      gsap.fromTo(el,
        {},
        {
          transform: `translateX(${m * 35}vw)`,
          scrollTrigger: {
            trigger: '.concept__pics__abs',
            start: "top center",
            end: "+=100%",
            scrub: 1,
            once: false,
            //markers: true,
            invalidateOnRefresh: true,
          }
        }
      )
    })
  
    gsap.fromTo('.site-index .concept__pics__abs__fig',
      {},
      {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        scrollTrigger: {
          trigger: '.concept__pics__abs',
          start: "top center",
          end: "+=100%",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  
  
    gsap.fromTo('.site-index .scroll-over.is-gray',
      {},
      {
        opacity: 1,
        scrollTrigger: {
          trigger: '.site-index .rooms',
          start: "top 75%",
          end: "top top",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
    gsap.fromTo('.site-index .scroll-over.is-black',
      {},
      {
        opacity: 0,
        scrollTrigger: {
          trigger: '.site-index .rooms',
          start: "top 75%",
          end: "top top",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  
    // 温泉
    ScrollTrigger.create({
      trigger: ".site-index .hotspring",
      start: "top top",
      end: "+=200%",
      pin: true,
      //markers: true
    })
  
    gsap.fromTo('.site-index .hotspring__pic figure',
      {},
      {
        scale: 1.1,
        scrollTrigger: {
          trigger: '.site-index .rooms',
          start: "bottom top",
          end: "top top",
          scrub: 3,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  
    gsap.fromTo('.site-index .hotspring__pic .hotspring__pic__over',
      {},
      {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
        scrollTrigger: {
          trigger: '.site-index .rooms',
          start: "bottom -50%",
          end: "+=100%",
          scrub: 2,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  }


}